import { AI_MODELING_EFFECT_DURATION_MS, calcElementDelayMs } from './aiModelingEffectTiming';
import { runAIModelingAppearEffect } from './runAIModelingAppearEffect';

const CLEAR_MARGIN_MS = 400;

// 連打すると前回のタイマーが次の再生中に発火して、作業中エフェクトを途中で消してしまう
let clearTimer: ReturnType<typeof setTimeout> | undefined;

/**
 * AIを動かさずにエフェクトを確認するためのプレビュー。デバッグモード時にビューのツールバーから呼ぶ。
 * 対象要素はモデルではなくDOMから集める。実際のエフェクトも同じ経路で要素を掴むため、
 * ここで見えるものが本番の見え方と一致する。
 */
export function playAIModelingEffectPreview(viewId: string, setWorkingViewIds: (viewIds: string[]) => void): void {
  const viewElement = document.querySelector(`[data-view-id="${CSS.escape(viewId)}"]`);
  const elementIds = viewElement
    ? [
        ...new Set(
          Array.from(viewElement.querySelectorAll('[data-model-element-id]'), (element) =>
            element.getAttribute('data-model-element-id')
          ).filter((id): id is string => id !== null)
        ),
      ]
    : [];

  clearTimeout(clearTimer);
  setWorkingViewIds([viewId]);
  runAIModelingAppearEffect(elementIds);

  // 帯を最低限流し切る時間は AIWorkingViewBackground 側が保証するので、ここは要素の出現に合わせるだけでよい
  const appearMs = calcElementDelayMs(elementIds.length - 1, elementIds.length) + AI_MODELING_EFFECT_DURATION_MS;
  clearTimer = setTimeout(() => setWorkingViewIds([]), appearMs + CLEAR_MARGIN_MS);
}
